import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../state";

const initialState: boolean = true;

export const subscriptionSlice = createSlice({
  name: "subscriptionSlice",
  initialState,
  reducers: {
    setSubscriptionState: (state, action) => {
      return action.payload;
    },
  },
});

export const selectSubscriptionState = (state: RootState): boolean =>
  state.subscription;

export const { setSubscriptionState } = subscriptionSlice.actions;
export default subscriptionSlice.reducer;
